import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
    selector: '[fiCustomValidator]',
    providers: [{ provide: NG_VALIDATORS, useExisting: FiCustomInputValidatorDirective, multi: true }],
    standalone: false,
})
export class FiCustomInputValidatorDirective implements Validator {
    @Input('fiCustomValidator') isInputInvalid: boolean;

    validate(control: AbstractControl): ValidationErrors {
        if (this.isInputInvalid) return { customError: true };

        return null;
    }
}
